import React from 'react';
import { FaLocationArrow, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';

const ContactAddress = () => {
  return (
    <div className="address">
        <div className="add">
          <div className="icon">
            <FaMapMarkerAlt />
          </div>
          <p>Plot 323 Saibaba colony, Nallagandla - Tellapur Rd, <br /> Fair Lands, Tellapur, <br /> Hyderabad, Serilingampalle (M), <br />
          Telangana 500019</p>
        </div>
        <div className="add">
          <div className="icon">
            <FaPhone />
          </div>
          <p>+91 7675929396 </p>
        </div>
        <div className="add">
          <div className="icon">
            <FaLocationArrow />
          </div>
          <p>LittleSanctum.montessori@gmail.com or at </p>
          
          <p>- admin@littlesanctumpreschools.in</p>
        </div>
    </div>
  )
}

export default ContactAddress
